const a = (n, i, o) => n && o ? `${n}${n.substring(
  n.length - 1,
  n.length
) === ">" ? "" : '<div style="margin-top: 14px;"/>'}<a href="${o}" target="_blank" style="margin-top: 14px;">${i.get("configuration-definitions-more-informations")}</a>` : n;
export {
  a as concatInformationLinkToText
};
//# sourceMappingURL=utils.js.map
